import { Briefcase, GraduationCap } from "lucide-react";
import { FadeIn } from "../components/FadeIn";
import { education, experiences } from "../content/portfolio";
import { useMediaQuery } from "../hooks/useMediaQuery";

function ExperienceBullets({ bullets }: { bullets: readonly string[] }) {
  const isPhone = useMediaQuery("(max-width: 767px)");

  if (!isPhone) {
    return (
      <ul>
        {bullets.map((bullet) => <li key={bullet}>{bullet}</li>)}
      </ul>
    );
  }

  const visibleBullets = bullets.slice(0, 2);
  const remainingBullets = bullets.slice(2);

  return (
    <div className="experience-bullets-compact">
      <ul>
        {visibleBullets.map((bullet) => <li key={bullet}>{bullet}</li>)}
      </ul>
      {remainingBullets.length > 0 && (
        <details className="experience-more">
          <summary>查看完整职责</summary>
          <ul>
            {remainingBullets.map((bullet) => <li key={bullet}>{bullet}</li>)}
          </ul>
        </details>
      )}
    </div>
  );
}

export function ExperienceSection() {
  return (
    <section id="experience" aria-labelledby="experience-heading" className="experience-section">
      <div className="experience-heading-row">
        <FadeIn as="h2" id="experience-heading" y={34} className="section-heading section-heading--dark">
          工作经历
        </FadeIn>
        <FadeIn as="p" delay={0.1} className="experience-lede">
          从物流渠道研发转向测试开发，保留编码能力，把质量保障推进到工具、平台和发布流程。
        </FadeIn>
      </div>

      <div className="experience-list">
        {experiences.map((experience, index) => (
          <FadeIn as="article" key={experience.company} delay={index * 0.08} className="experience-record">
            <div className="experience-index">
              <Briefcase aria-hidden="true" />
              <span>0{index + 1}</span>
            </div>
            <div className="experience-role">
              <p>{experience.period}</p>
              <h3>{experience.company}</h3>
              <strong>{experience.role}</strong>
            </div>
            <ExperienceBullets bullets={experience.bullets} />
          </FadeIn>
        ))}
      </div>

      <FadeIn className="education-record">
        <GraduationCap aria-hidden="true" />
        <div>
          <span>教育经历</span>
          <strong>{education.school}</strong>
        </div>
        <p>{education.major}</p>
        <time>{education.period}</time>
      </FadeIn>
    </section>
  );
}
